import { useQuery, useQueries } from "@tanstack/react-query";
import { fetchApi } from "@/lib/api";

export const useSignedMedia = (url?: string | null, forceRetryKey?: string) => {
  const { data, isError, isPending } = useQuery({
    queryKey: [`media-${url}`, forceRetryKey],
    queryFn: async () => {
      const { data } = await fetchApi<string>({
        url: "/v1/media/sign",
        method: "POST",
        data: { url },
      });

      return data;
    },
    enabled: Boolean(url),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });

  return {
    url: data,
    isError,
    isPending,
  };
};

export const useBatchSignedMedia = (urls: (string | null | undefined)[]) => {
  const queries = useQueries({
    queries: urls.map((url) => ({
      queryKey: [`media-${url}`],
      queryFn: async () => {
        const { data } = await fetchApi<string>({
          url: "/v1/media/sign",
          method: "POST",
          data: { url },
        });

        return data;
      },
      enabled: Boolean(url),
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
    })),
  });

  return queries.map((query) => ({
    url: query.data,
    isError: query.isError,
    isPending: query.isPending,
  }));
};
